module.exports = __webpack_public_path__ + "img/winning_form-logo_white1.d73abfac.svg";